export const ja_home = {
  main: "Change the way you see the world with Ubiq",
  sub: "Ubiqはクリエイターがグラフィックスを投稿し、ユーザーは好きなクリエイターをフォローできる、グラフィック特化型のUGCメディアプラットフォームです。広告閲覧報酬を自社トークンで、クリエイターはもちろん、ユーザーにも還元し、クリエイタートークンエコノミーを作ります。"
}